<template>
  <div></div>
</template>

<script>
export default {
  name: 'Order'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/My/Order.vue